/**
 * Dev-login session (TEST/DEV ONLY).
 *
 * Stores a dev-login token + identity in sessionStorage so the app can treat the
 * operator as logged-in without MSAL. This is frontend convenience only — the
 * real gate is the backend, which refuses to mint or accept a dev token on
 * production. The host check here is defence-in-depth: never surface dev-login
 * on intern.fullframe.nl even if a stale token were present.
 */
const KEY = 'ff_dev_session';

const host = (typeof window !== 'undefined' && window.location.hostname) || '';
const isProdHost = host === 'intern.fullframe.nl';
export const isDevLoginHost =
  !isProdHost &&
  (host === 'test.fullframe.nl' || host === 'localhost' || host === '127.0.0.1');

function tokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

/** Returns { token, email, role } if a valid dev session exists, else null. */
export function getDevSession() {
  if (!isDevLoginHost) return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (!s?.token || tokenExpired(s.token)) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return s;
  } catch {
    return null;
  }
}

export function setDevSession(session) {
  sessionStorage.setItem(KEY, JSON.stringify(session));
}

export function clearDevSession() {
  sessionStorage.removeItem(KEY);
}
